import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '__generated__/globalTypes';
import type { SupportedCardSet } from 'lib/cardSets';
import { withFragments } from 'lib/gql';

import type { getCommonCardShardsCount_currentUser } from './__generated__/index.graphql';

export const getCommonCardShardsCount = withFragments(
  (
    currentUser: Nullable<getCommonCardShardsCount_currentUser>,
    cardSet: SupportedCardSet = 'common-base-set'
  ) => {
    return (
      currentUser?.cardShardsChests?.find(
        chest =>
          chest.rarity === Rarity.common && chest.cardSet?.slug === cardSet
      )?.cardShardsCount || 0
    );
  },
  {
    currentUser: gql`
      fragment getCommonCardShardsCount_currentUser on CurrentUser {
        slug
        cardShardsChests(
          sport: $sport
          rarities: [common, limited, rare, super_rare, unique]
        ) {
          id
          rarity
          cardShardsCount
          cardSet {
            slug
          }
        }
      }
    ` as TypedDocumentNode<getCommonCardShardsCount_currentUser>,
  }
);
